import _styled from "styled-components";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import Box from "../../../Styled/Box";
import { Frame, Main } from "../ToolModal";
import BackButton from "./BackButton";
import ErrorComponent from "./ErrorComponent";
import Loading from "./Loading";
import SearchForm from "./SearchForm";
import SearchResults from "./SearchResults";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ItemSearchTool = observer(props => {
  var _itemSearchProvider$l;
  const {
    viewState,
    item,
    itemSearchProvider,
    t
  } = props;
  const itemName = CatalogMemberMixin.isMixedInto(item) ? item.name : "Item";
  const [state, setState] = useState({
    is: "loadingParameters"
  });
  const [parameters, setParameters] = useState([]);
  const [query, setQuery] = useState({});
  useEffect(function loadParameters() {
    itemSearchProvider.initialize().then(() => itemSearchProvider.describeParameters().then(parameters => {
      setState({
        is: "search"
      });
      setParameters(parameters);
      setQuery({});
    })).catch(error => {
      console.warn(error);
      setState({
        is: "error",
        error
      });
    }).finally(() => {
      var _props$afterLoad;
      return (_props$afterLoad = props.afterLoad) === null || _props$afterLoad === void 0 ? void 0 : _props$afterLoad.call(props);
    });
  }, /* eslint-disable-next-line react-hooks/exhaustive-deps */
  [itemSearchProvider]);
  useEffect(function closeSearchTool() {
    // Close item search tool if the parent item is disabled or removed from
    // the workbench
    const disposeListener = onItemDisabledOrRemovedFromWorkbench(item, () => viewState.closeTool());
    return disposeListener;
  }, /* eslint-disable-next-line react-hooks/exhaustive-deps */
  [item]);
  const setResults = (query, results) => {
    setQuery(query);
    setState({
      is: "results",
      results
    });
  };
  const searchAgain = () => setState({
    is: "search"
  });
  const loadIndexForParameter = (_itemSearchProvider$l = itemSearchProvider.loadParameterHint) === null || _itemSearchProvider$l === void 0 ? void 0 : _itemSearchProvider$l.bind(itemSearchProvider);
  return /*#__PURE__*/_jsx(Frame, {
    viewState: viewState,
    title: t("itemSearchTool.title", {
      itemName
    }),
    children: /*#__PURE__*/_jsxs(Main, {
      textLight: true,
      light: true,
      children: [/*#__PURE__*/_jsxs(_StyledBox, {
        centered: true,
        children: [state.is === "loadingParameters" && /*#__PURE__*/_jsx(Loading, {
          children: t("itemSearchTool.loading")
        }), state.is === "error" && /*#__PURE__*/_jsx(ErrorComponent, {
          children: t("itemSearchTool.loadError")
        }), state.is === "search" && parameters.length === 0 && /*#__PURE__*/_jsx(ErrorComponent, {
          children: t("itemSearchTool.noParameters")
        })]
      }), state.is === "search" && parameters.length > 0 && /*#__PURE__*/_jsx(SearchForm, {
        itemSearchProvider: itemSearchProvider,
        parameters: parameters,
        query: query,
        onResults: setResults,
        onValueChange: loadIndexForParameter
      }), state.is === "results" && /*#__PURE__*/_jsx(SearchResults, {
        item: item,
        results: state.results,
        template: item.search.resultTemplate
      }), state.is === "results" && /*#__PURE__*/_jsx(BackButton, {
        onClick: searchAgain,
        children: t("itemSearchTool.backBtnText")
      })]
    })
  });
});

/**
 * Callback when the given item is disabled or removed from the workbench.
 *
 * @param item The item to watch
 * @param callback The function to call when the event happens
 * @return A function to dispose the listener
 */
function onItemDisabledOrRemovedFromWorkbench(item, callback) {
  const disposer = autorun(() => {
    if (item.show === false || item.terria.workbench.contains(item) === false) callback();
  });
  return disposer;
}
export default withTranslation()(ItemSearchTool);
var _StyledBox = _styled(Box).withConfig({
  displayName: "ItemSearchTool___StyledBox",
  componentId: "sc-uahz0f-0"
})(["text-align:center;"]);